// extracted by mini-css-extract-plugin
export default {"notification":"styles_notification__AErRK","container":"styles_container__j8ApV","warning":"styles_warning__MFpdB","error":"styles_error__HaFQ1","success":"styles_success__kHmM4"};